import { HttpClient } from '@angular/common/http';
import { Injectable, inject, makeStateKey } from '@angular/core';

import { Observable } from 'rxjs';

import { LanguageService } from '@fcom/ui-translate';
import { ConfigService } from '@fcom/core/services/config/config.service';
import { StateTransferService } from '@fcom/core/services/state-transfer/state-transfer.service';
import { stringHashCode } from '@fcom/core/utils/utils';
import { finShare, retryWithBackoff } from '@fcom/rx';

import {
  OndLocationsRequestBody,
  OndLocationsResponse,
  OndPairRequestBody,
  OndPairResponse,
} from '../interfaces/ond-marketing-offers.interface';

const RETRY_COUNT = 2;

@Injectable()
export class OndMarketingDataService {
  private http = inject(HttpClient);
  private configService = inject(ConfigService);
  private languageService = inject(LanguageService);
  private stateTransferService = inject(StateTransferService);

  public fetchLocations(destinationLocationCodes: string[]): Observable<OndLocationsResponse> {
    const body: OndLocationsRequestBody = {
      destinations: destinationLocationCodes,
      lang: this.languageService.langValue,
    };

    return this.stateTransferService
      .wrapToStateCache(makeStateKey<OndLocationsResponse>(`ond-loc-${stringHashCode(JSON.stringify(body))}`), () => {
        return this.http
          .post<OndLocationsResponse>(`${this.configService.cfg.ondMarketingOffersUrl}/fetch-locations`, body)
          .pipe(retryWithBackoff(RETRY_COUNT));
      })
      .pipe(finShare());
  }

  public fetchLocationPairs(body: OndPairRequestBody): Observable<OndPairResponse> {
    return this.stateTransferService
      .wrapToStateCache(makeStateKey<OndPairResponse>(`ond-pairs-${stringHashCode(JSON.stringify(body))}`), () => {
        return this.http.post<OndPairResponse>(
          `${this.configService.cfg.ondMarketingOffersUrl}/fetch-location-pairs`,
          body
        );
      })
      .pipe(finShare());
  }
}
